module.exports = __webpack_public_path__ + "img/0Q3A3407_L_Foamcore_MockedUp.eda3d210.jpg";